
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { User } from '@/models/main';
import { AirRoadGeneralJob } from '@/models/airRoad';
import { jobItemsTypes } from '@/utils/PortalConstants';

import { mapState } from 'vuex';
import { formatDateStringWithTZ } from '@/utils/InputProcessingUtilities';

@Component({
  computed: {
    ...mapState('moduleUser', { user: 'user' }),
  },
})
export default class Header extends Vue {
  @Prop({ type: Array, required: true }) public tableData!: AirRoadGeneralJob;
  @Prop({ type: Boolean, required: true }) public loading!: boolean;
  @Prop({ type: Number, required: false }) public statusCode!: number;

  private user!: User;

  // to use func in the template
  private formatDateStringWithTZ = formatDateStringWithTZ;

  public subtitle!: string;

  private tableHeaders = [
    { text: '', value: 'checked', align: 'cell checkbox' },
    { text: 'Id', value: 'rockhopper_id', align: 'cell text' },
    { text: 'Date', value: 'rockhopper_date', align: 'cell text nowrap' },
    { text: 'Customer code', value: 'customer_code', align: 'cell text' },
    { text: 'Stop 1', value: 'stops[0].name', align: 'cell text wrapped' },
    { text: 'Stop 2', value: 'stops[1].name', align: 'cell text wrapped' },
    { text: 'Stop 3', value: 'stops[2].name', align: 'cell text wrapped' },
    { text: 'AR status', value: 'ar_status', align: 'cell text' },
    { text: 'Weight', value: 'ar_total_weight', align: 'cell' },
    { text: 'Volume', value: 'ar_total_volume', align: 'cell' },
    { text: 'Items', value: 'ar_total_items', align: 'cell' },
    { text: 'Type', value: 'ar_items_type', align: 'cell' },
  ];

  private jobsStatuses = [
    'Not booked',
    'Booked',
    'Departed from Stop1',
    'PoD received',
    'Unknown',
    'Failed to book',
    'Queued to book',
  ];
  private jobsStatusesCodes = [0, 1, 2, 3, 1000, 1001, 1002];

  // CALC
  private calcOpen = 0;
  private calcData = {
    width: 0,
    height: 0,
    depth: 0,
  };

  // JOBS TYPES
  private jobItemsTypes = jobItemsTypes;

  // TABLE CALC
  private calcClicked(id): void {
    this.calcOpen = id;
  }
  private calcCloseClicked(): void {
    this.calcOpen = 0;
    this.calcData = {
      width: 0,
      height: 0,
      depth: 0,
    };
  }
  private calcChanged(item): void {
    //   limiting calc inputs length to 5
    Object.values(this.calcData).map((dimension, idx) => {
      if (String(dimension).length >= 5) {
        this.calcData[Object.keys(this.calcData)[idx]] = Number(String(dimension).slice(0, -1));
      }
    });
    const calculatedValue = (this.calcData.width * this.calcData.height * this.calcData.depth) / 1000000;
    const calcValueRounded = Math.ceil(calculatedValue * 1000) / 1000;
    this.$emit('calcChange', item, calcValueRounded);
  }

  @Watch('statusCode')
  private watchToStatusCode(statusCode) {
    const errorColumnIndex = this.tableHeaders.findIndex(header => header.value === 'ar_error_text');
    if (errorColumnIndex === -1) {
      if (statusCode === 1001) {
        this.tableHeaders.splice(this.tableHeaders.length, 0, {
          text: 'Error text',
          value: 'ar_error_text',
          align: 'left',
        });
      }
    } else {
      if (statusCode !== 1001) {
        this.tableHeaders.splice(errorColumnIndex, 1);
      }
    }
  }
}
